const dev = process.env.NODE_ENV === 'development'
const carCode = 'id3' // 车辆代码
const ossUrl = dev ? '' : '' // url 配置
export default {
    dev: dev,
    carConfig: {
        id3: {
            carCode: carCode,
            cameraPositon: [-65, 158, 878],
            interiorColors: [],
            pano: {
                interiorScreen: {
                    hei: 'hei',
                    hei_back: 'hei_back'
                },
            },
        },
    },
    decoderPath: ossUrl + 'fontre/js/',
    publicPath: ossUrl + 'fontre',
    useBasis: false,
    basisExcludeList: ['env.hdr', 'light_map_c.jpg', 'huanjingqiu.jpg', 'Dzhu_map_c.jpg'],
    bokehConfig: {
        enable: false,
        focus: 300.0,
        aperture: 5,
        maxblur: 0.01,
        maxBlurDiatance: 580
    }
}
